import { inChinaIcpHost } from '../utils/pathHelper';
import siteCookie from '../utils/siteCookie';
import trackingEvents from './_trackingEvents';
import { marugeTrackItemPurchased } from './affiliate/maruge';
import { wamazingTrackItemPurchased } from './affiliate/wamazing';
import { twitterTrack } from './twitter'

const CSS_YADO = '.js-yado-order-paid-amount';
const CSS_SNOW = '.js-order-paid-amount';
const CSS_INSURANCE = '.js-standard-insurance-order-paid-amount';
const CSS_INSURANCE_LIABILITY = '.js-liability-insurance-order-paid-amount';
const trackingEntries = [CSS_YADO, CSS_SNOW, CSS_INSURANCE, CSS_INSURANCE_LIABILITY];
// 合計と割引は必ず1つ
const CSS_TOTAL = '.js-paid-amount';
const COOKIE_NAME = 'SNOW_CART_CONVERSION_TRACKING';


function getUIDs(element: HTMLElement): { uid1: string, uid2: string }|null {
  if (element == null) { return null; }
  const uid1: string = element.getAttribute('data-uid1');
  const uid2: string = element.getAttribute('data-uid2');
  if (!uid1 || !uid2) {
    return null;
  }
  return { uid1, uid2 };
}

function getAmount(element: HTMLElement): { includingTax: number, excludingTax: number }|null {
  if (element == null) { return null; }
  const includingTax: string = element.getAttribute('data-including-tax');
  const excludingTax: string = element.getAttribute('data-excluding-tax');
  if (!includingTax || !excludingTax) {
    return null;
  }
  return {
    includingTax: Number(includingTax),
    excludingTax: Number(excludingTax),
  };
}


export default function trackItemPurchased(): void {

  const eventName: string = trackingEvents.ITEM_PURCHASED;
  const totalAmountElement: HTMLElement = document.querySelector(CSS_TOTAL);
  const { includingTax, excludingTax } = getAmount(totalAmountElement);
  const { uid1, uid2 } = getUIDs(totalAmountElement);

  // 保存して再発火を防止
  const history: string[] = JSON.parse(siteCookie.get(COOKIE_NAME)) || [];
  if (history.indexOf(uid1) !== -1) {
    console.log(`${eventName} is already tracked`, uid1);
    return;
  }
  siteCookie.set(COOKIE_NAME, JSON.stringify([...history, uid1]));

  // コンバージョンはOrderGroup単位で1度だけ発火
  // https://github.com/wamazing/wamazing-snow/issues/3630

   // Affiliate
  if (inChinaIcpHost()) {
    wamazingTrackItemPurchased(excludingTax, uid1, uid2);
  } else {
    marugeTrackItemPurchased(includingTax, uid1, uid2);
  }

  // twitter track
  twitterTrack()
}
